import type * as Types from '../../../graphql/generated-base';

import type { DocumentNode } from 'graphql';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from '@graphql/react-hooks';
export type WebsiteV2SitesByEventQueryVariables = Types.Exact<{
  eventId: Types.Scalars['String'];
}>;

export type WebsiteV2SitesByEventQuery = {
  __typename?: 'Query';
  carbonWebsiteSitesByEventId: Array<{
    __typename?: 'CarbonWebsiteSite';
    id: string;
    name: string;
    updatedAt: any;
    published: boolean;
    publishedAt?: any | null;
    pipelineRuns: Array<{
      __typename?: 'CarbonWebsiteRunStatus';
      runId: string;
      status: string;
      startedAt: string;
      currentStep?: string | null;
      steps: Array<{ __typename?: 'CarbonWebsiteStepResult'; step: string }>;
    }>;
  }>;
};

export const WebsiteV2SitesByEventDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'WebsiteV2SitesByEvent' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'eventId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'carbonWebsiteSitesByEventId' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'eventId' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'eventId' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'published' } },
                { kind: 'Field', name: { kind: 'Name', value: 'publishedAt' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'pipelineRuns' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'runId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'startedAt' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'currentStep' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'steps' },
                        selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'step' } }] },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useWebsiteV2SitesByEventQuery__
 *
 * To run a query within a React component, call `useWebsiteV2SitesByEventQuery` and pass it any options that fit your needs.
 * When your component renders, `useWebsiteV2SitesByEventQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWebsiteV2SitesByEventQuery({
 *   variables: {
 *      eventId: // value for 'eventId'
 *   },
 * });
 */
export function useWebsiteV2SitesByEventQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<WebsiteV2SitesByEventQuery, WebsiteV2SitesByEventQueryVariables>) {
  return ApolloReactHooks.useQuery<WebsiteV2SitesByEventQuery, WebsiteV2SitesByEventQueryVariables>(WebsiteV2SitesByEventDocument, baseOptions);
}
export function useWebsiteV2SitesByEventLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<WebsiteV2SitesByEventQuery, WebsiteV2SitesByEventQueryVariables>) {
  return ApolloReactHooks.useLazyQuery<WebsiteV2SitesByEventQuery, WebsiteV2SitesByEventQueryVariables>(WebsiteV2SitesByEventDocument, baseOptions);
}
export type WebsiteV2SitesByEventQueryHookResult = ReturnType<typeof useWebsiteV2SitesByEventQuery>;
export type WebsiteV2SitesByEventLazyQueryHookResult = ReturnType<typeof useWebsiteV2SitesByEventLazyQuery>;
export type WebsiteV2SitesByEventQueryResult = Apollo.QueryResult<WebsiteV2SitesByEventQuery, WebsiteV2SitesByEventQueryVariables>;
